import { Subtitle02 } from 'Components/designSystem';
import { memo } from 'react';
import styled, { css } from 'styled-components';

export type StatusVariant = 'regular' | 'warning' | 'success' | 'error';

export interface StatusProps {
    className?: string;
    variant: StatusVariant;
    content?: string;
}

function Status(props: StatusProps) {
    const { className, content, variant } = props;

    if (!content) {
        return null;
    }

    return (
        <Root className={ className }
            variant={ variant }
        >
            { content }
        </Root>
    );
}

const variantDependentStyle = ({ variant }: { variant: StatusVariant }) => {
    switch (variant) {
        case 'success':
            return css`
                color: ${ ({ theme }) => theme.color.green.green_80 };
                background-color: ${ ({ theme }) => theme.color.green.green_10 };
            `;
        case 'warning':
            return css`
                color: #EA8844;
                background-color: ${ ({ theme }) => theme.color.gold.gold_10 };
            `;
        case 'error':
            return css`
                color: ${ ({ theme }) => theme.color.red.red_80 };
                background-color: ${ ({ theme }) => theme.color.red.red_10 };
            `;
        case 'regular':
        default:
            return css`
                background-color: ${ ({ theme }) => theme.color.grey.grey_10 };
            `;
    }
};

const Root = styled(Subtitle02)<{ variant: StatusVariant }>`
    padding: ${ ({ theme: { size } }) => `${ size.size_2 } ${ size.size_10 }` };
    border-radius: ${ ({ theme }) => theme.radius.radius_2 };
    height: fit-content;

    ${ variantDependentStyle }
`;

export default memo(Status);
